import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { useSlateStatic } from "slate-react";
import { units } from "@m/alchemy-theme";
import { PopperBox } from "../../../../popper/PopperBox";
import { Field } from "../../../field/Field";
import { Input } from "../../../input/Input";
import { Checkbox } from "../../../checkbox/Checkbox";
import { IconButton } from "../../../../icon-button/IconButton";
import { Button } from "../../../../button/Button";
import { ButtonGroup } from "../../../../button-group/ButtonGroup";
import { Text } from "../../../../text/Text";
import { useSlateRTE } from "../../SlateRTEContext";
import { CancelXIcon } from "../../../../icons/CancelXIcon";
import { getSelectedLink, insertLink, removeLink, updateLink } from "./link-utilities";
export const LinkMenu = ({ closeAndReturnFocus, closeAndFocusEditor }) => {
    const editor = useSlateStatic();
    const { stringMap } = useSlateRTE();
    const { selectedLink, selectedText } = getSelectedLink(editor);
    const [text, setText] = useState(selectedText || "");
    const [href, setHref] = useState(selectedLink?.href || "");
    const [openInNewTab, setOpenInNewTab] = useState(selectedLink?.openInNewTab ?? false);
    // Prevent unlink button from appearing while menu is closing after "apply"
    const isUpdatingRef = useRef(Boolean(selectedLink));
    const hrefInputRef = useRef(null);
    const textInputRef = useRef(null);
    // only submit text when selectedText available
    const submitText = selectedText === false ? "" : text || href;
    return (_jsx(PopperBox, { maxWidth: "90vw", style: { width: "320px" }, hasPadding: false, children: _jsxs("form", { "data-testid": "LinkMenu", style: { padding: units(2), display: "flex", gap: units(2), flexDirection: "column" }, onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (href) {
                    if (selectedLink) {
                        updateLink({
                            editor,
                            href,
                            openInNewTab,
                            text: submitText,
                            element: selectedLink
                        });
                    }
                    else {
                        insertLink({ href, editor, text: submitText, openInNewTab });
                    }
                }
                else if (selectedLink) {
                    removeLink(editor, { element: selectedLink });
                }
                closeAndFocusEditor();
            }, children: [_jsx(Text, { typeStyle: "subHeaderM", children: isUpdatingRef.current ? stringMap.updateLink : stringMap.addLink }), _jsx(Field, { isFullWidth: true, layoutVariant: "inline", label: stringMap.linkHref, input: _jsx(Input, { ref: hrefInputRef, value: href, onChange: (e) => setHref(e.currentTarget.value) }), endAdornment: href ? (_jsx(IconButton, { onClick: () => {
                            hrefInputRef.current?.focus();
                            setHref("");
                        }, icon: _jsx(CancelXIcon, { "aria-hidden": "true" }), tooltipContents: stringMap.removeLink })) : (_jsx(_Fragment, {})) }), selectedText !== false && (_jsx(Field, { isFullWidth: true, layoutVariant: "inline", label: stringMap.linkText, input: _jsx(Input, { ref: textInputRef, value: text, placeholder: href, onChange: (e) => setText(e.currentTarget.value) }) })), _jsx(Checkbox, { checked: openInNewTab, label: stringMap.openInNewTab, disabled: !href, onChange: (e) => setOpenInNewTab(e.currentTarget.checked) }), _jsxs(ButtonGroup, { style: { justifyContent: "flex-end" }, children: [_jsx(Button, { priority: "tertiary", onClick: () => {
                                setHref(selectedLink?.href || "");
                                closeAndReturnFocus();
                            }, size: "small", children: stringMap.cancel }), _jsx(Button, { type: "submit", size: "small", disabled: !href && !isUpdatingRef.current, children: isUpdatingRef.current ? (href ? stringMap.update : stringMap.removeLink) : stringMap.add })] })] }) }));
};
